import { createTheme, adaptV4Theme } from '@mui/material/styles';
// import lightblue from '@mui/material/colors/lightBlue'
// import orange from '@mui/material/colors/orange'

// See https://material-ui.com/customization/color/
// See https://cimdalli.github.io/mui-theme-generator/

export const theme = createTheme(adaptV4Theme({
  // palette: {
  //   primary: lightblue,
  //   secondary: orange
  // }
  palette: {
    primary: { main: '#4CEFDA' },
    secondary: { main: '#4790CC' },
    action: {
      disabledBackground: '#919293',
    }
    // primary: {
    //   light: '#CC4C47',
    //   main: '#4CEFDA',
    //   dark: '#353838',
    //   contrastText: '#fff'
    // },
    // secondary: {
    //   light: '#5DE8B5',
    //   main: '#4790CC',
    //   dark: '#828F99',
    //   contrastText: '#fff'
    // }
  },
  typography: {
    // fontFamily: [/*'acumin-pro-condensed', */ 'proxima-nova'].join(',')
  }
}))

export default theme
